<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import chartUtil from "../common/chartUtil";
import * as Plotly from "plotly.js/dist/plotly.min.js";
import DropdownCheckbox from "../common/DropdownCheckbox.vue";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { defaults } from "ol/interaction";
import XYZ from "ol/source/XYZ.js";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import Feature from "ol/Feature.js";
import Point from "ol/geom/Point.js";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import utils from "../common/utils";
let src = "EPSG:4326";
let dest = "EPSG:3857";
const defaultPoint = [127.89721080738167, 36.239911296418654];

export default {
  name: "dashboard",
  components: {
    AgGridVue,
    DropdownCheckbox,
    VueSelect,
  },
  data() {
    return {
      statusTimer: null,
      isSensorRatioExpanded: false,
      selectedStructureIdx: null,
      isShowOnlyAlarmStructure: false,
      isAlarmSensorRatioLoading: false,
      isAlarmSensorRatioModalLoading: false,

      project: {
        columnDefs: null,
        rowData: [],
        localeText: { noRowsToShow: "조회 결과가 없습니다." },
        rowSelection: "single",
        toolPanelSuppressSideButtons: true,
        onGridReady: (params) => {
          params.api.sizeColumnsToFit();
        },
        onRowDataChanged: (params) => {
          params.api.sizeColumnsToFit();
        },
        enableSorting: true,
        enableColResize: true,
        rowHeight: 35,
        // headerHeight: 35,
      },
      search: {
        project: {
          options: [],
          selectedIdList: [],
        },
        structure: {
          options: [],
          selectedIdList: [],
        },
        condition: {
          options: [
            { value: "xDeviceCount", text: "디바이스 장애", isChecked: false },
            {
              value: "xSolarDeviceCount",
              text: "태양광 디바이스 장애",
              isChecked: false,
            },
            {
              value: "xAccSensorCount",
              text: "가속도 센서 장애",
              isChecked: false,
            },
            {
              value: "xTempSensorCount",
              text: "온도 센서 장애",
              isChecked: false,
            },
            {
              value: "xDispSensorCount",
              text: "변위 센서 장애",
              isChecked: false,
            },
            {
              value: "xTiltSensorCount",
              text: "경사 센서 장애",
              isChecked: false,
            },
            {
              value: "xStrainSensorCount",
              text: "변형률 센서 장애",
              isChecked: false,
            },
            {
              value: "xWehightSensorCount",
              text: "하중 센서 장애",
              isChecked: false,
            },
          ],
          selectedIdList: [],
        },
      },
      statusBorder: {
        structureTypeCnt: [],
        structureStatus: [],
      },
      isFacilityInfoVisible: false,
      selectedFacilityInfo: {
        stName: null,
        stAddr: null,
        stTypeMain: null,
        stTypeSub: null,
        regDate: null,
        image: [],
        showImageIdx: null,
        showImageEven: null,
        showImageOdd: null,
        imagePolling: null,
        projectName: null,
      },
      showLegend: true,

      structureList: [],
      vworldMapKey: null,
      map: null,
      view: null,
      markerSource: new VectorSource({
        features: [],
      }),
      selectedMarkerFeature: null,
      modelValue: null,
      isVisibleWeatherPanel: false,

      isLoading: false,
      isBlankPanel: true,
      chartData: [],
      chartConfig: null,
      LoadYn: false,
      isGnss: false,
      chartRange: [],
      chartRangeList: [],
    };
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserAuth",
      "getCenterBus",
      "getUserInfo",
      "getWindowHeight",
      "getWindowWidth",
      "getAlertOptions",
    ]),
    queueColor: function () {
      if (this.almCount.queuecnt === 0) return "#fff";
      else return "#FED466";
    },
    unchkColor: function () {
      if (this.almCount.unchkcnt === 0) return "#fff";
      else return "#ff4";
    },
    chkColor: function () {
      if (this.almCount.chkcnt === 0) return "#fff";
      else return "#ff8b1d";
    },
    procColor: function () {
      if (this.almCount.proccnt === 0) return "#fff";
      else return "#0653a1";
    },
    needFieldColor: function () {
      if (this.almCount.needfieldcnt === 0) return "#fff";
      else return "#FD737F";
    },
    fieldColor: function () {
      if (this.almCount.fieldcnt === 0) return "#fff";
      else return "#ca2231";
    },
    weatherIcon: function () {
      return this.isVisibleWeatherPanel ? "fas fa-eye-slash" : "fas fa-eye";
    },
  },
  beforeMount() {
    this.project.columnDefs = [
      {
        headerName: "프로젝트",
        field: "projectname",
        width: 160,
      },
      {
        headerName: "디바이스",
        groupId: "device",
        marryChildren: true,
        children: [
          { headerName: "전체", field: "tot_dev_cnt", width: 80 },
          {
            headerName: "장애",
            field: "alm_dev_cnt",
            width: 80,
            cellStyle: function (params) {
              let fontcolor = "#b4b7bd";
              if (params.value > 0) fontcolor = "#e42728";
              return { color: fontcolor };
            },
          },
        ],
      },
      {
        headerName: "센서",
        groupId: "sensor",
        marryChildren: true,
        children: [
          { headerName: "전체", field: "sensor_cnt", width: 80 },
          {
            headerName: "장애",
            field: "alm_sensor_cnt",
            width: 80,
            cellStyle: function (params) {
              let fontcolor = "#b4b7bd";
              if (params.value > 0) fontcolor = "#e42728";
              return { color: fontcolor };
            },
          },
        ],
      },
      { headerName: "센서장애율(%)", field: "sensor_alm_ratio", width: 115 },
      {
        headerName: "목표장애율(%)",
        field: "targetsensoralarmratio",
        width: 115,
      },
    ];
  },
  mounted() {
    this.getCenterBus.$on("resizeEvent", (param) => {
      this.resizeEvent();
    });
    this.isAlarmSensorRatioLoading = true;
    this.isAlarmSensorRatioModalLoading = true;

    this.getProjectStatList();
    this.getProjectList();
    this.getStructureList([], true);
    this.getStructureStatus(null, true);
    this.getAlarmSensorRatio(false);

    this.initializeMap();

    this.startMonitoring();
  },
  destroyed() {
    this.stopMonitoring();
    this.getCenterBus.$off("resizeEvent");
  },
  methods: {
    isTotalStation: utils.isTotalStation,
    isDynamicSensor: utils.isDynamicSensor,
    isCableTensionSensor: utils.isCableTensionSensor,
    isGNSS: utils.isGNSS,
    isBGW: utils.isBGW,
    isLGW: utils.isLGW,
    isOptiFBG: utils.isOptiFBG,
    ...mapMutations(["setPageMoveParams", "setAlertTitle"]),
    resizeEvent() {
      this.project.api.sizeColumnsToFit();
      this.resizeWeatherChart();
    },
    startMonitoring() {
      if (this.statusTimer === null) {
        this.statusTimer = setInterval(() => {
          this.getProjectStatList();
          this.getAlarmSensorRatio(false);
          this.getStructureStatus(null, true);
        }, 15 * 60 * 1000);
      }
    },
    stopMonitoring() {
      if (this.statusTimer !== null) {
        clearInterval(this.statusTimer);
        this.statusTimer = null;
      }
    },
    getProjectStatList() {
      var reqBody = {};
      this.$http
        .post("/dashboard/getProjectStat", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var stat = res.data.data.statList;
            this.project.api.setRowData(stat);
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProjectList() {
      var reqBody = {};
      this.$http
        .post("/comn/getProjectListInService", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.search.project.options = [
              ...res.data.data.map((item) => {
                return {
                  value: item.id,
                  text: item.name,
                  isChecked: true,
                };
              }),
            ];
            this.search.project.selectedIdList = res.data.data.map(
              (item) => item.id
            );
          } else {
            this.setAlertTitle("프로젝트 목록 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onChangeProject(v) {
      this.search.project.selectedIdList = v;
      this.getStructureList(v);
    },
    getStructureList(projectIds, isInit = false) {
      var reqBody = {};
      if (!isInit) {
        reqBody.projectIds = projectIds;
      }
      this.$http
        .post("/comn/getStructureListByProjectIds", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.search.structure.options = res.data.data.map((item) => {
              return { value: item.id, text: item.name, isChecked: true };
            });
            this.search.structure.selectedIdList = res.data.data.map(
              (item) => item.id
            );
          } else {
            this.setAlertTitle("구조물 목록 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onChangeStructure(v) {
      this.search.structure.selectedIdList = v;
    },
    onChangeCondition(v) {
      this.search.condition.selectedIdList = v;
    },
    getStructureStatus(e, isInit = false) {
      this.statusBorder.structureTypeCnt = [];
      this.statusBorder.structureStatus = [];

      var reqBody = {};
      if (!isInit) {
        this.reset();
        reqBody.projectIds = this.search.project.selectedIdList;
        reqBody.structureIds = this.search.structure.selectedIdList;
        if (this.search.condition.selectedIdList.length) {
          this.search.condition.selectedIdList.forEach((item) => {
            reqBody[item] = 1;
          });
        }
      }
      this.$http
        .post("/structureStatus/getStructureStatusAdv", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let data = res.data.data;
            this.statusBorder.structureTypeCnt = data.structureTypeCnt;
            this.statusBorder.structureStatus = data.structureStatus;
            this.structureList = data.structureStatus;
            this.makeMarker();
          } else {
            this.setAlertTitle("구조물 현황 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    searchStructure() {
      const result = this.structureList.filter(
        (item) => item.structureId === this.modelValue
      );
      if (result.length) this.changeData(result[0]);
    },
    changeData(data) {
      this.isFacilityInfoVisible = true;
      this.getFacilityInfo(
        data.structureId,
        data.structureName,
        data.structureAddress,
        data.structureRegistrationDate
      );
      this.getWeatherInfo(data.structureId);
      this.getChartData(data.structureId);

      if (this.selectedMarkerFeature) {
        this.setUnSelectMarkerStyle(this.selectedMarkerFeature);
        this.selectedMarkerFeature = null;
      }
      let features = this.markerSource.getFeatures();
      let feature = features.find(
        (x) => x.values_.data.structureId === data.structureId
      );
      this.selectedMarkerFeature = this.setSelectMarkerStyle(feature);
      this.setMapView(data.lng, data.lat, 12, true);
    },
    reset() {
      this.isFacilityInfoVisible = false;
      this.initFacilityInfo();
      const currentSelectedMarker = this.selectedMarkerFeature;
      if (currentSelectedMarker) {
        this.setUnSelectMarkerStyle(this.selectedMarkerFeature);
        this.selectedMarkerFeature = null;
      }
      this.setMapView(null, null, null, false);
    },
    initFacilityInfo() {
      this.destroyImagePolling();
      this.selectedFacilityInfo.stName = null;
      this.selectedFacilityInfo.stAddr = null;
      this.selectedFacilityInfo.stTypeMain = null;
      this.selectedFacilityInfo.stTypeSub = null;
      this.selectedFacilityInfo.regDate = null;
      this.selectedFacilityInfo.image = [];
      this.selectedFacilityInfo.showImageIdx = null;
      this.selectedFacilityInfo.showImageEven = null;
      this.selectedFacilityInfo.showImageOdd = null;
      this.selectedFacilityInfo.projectName = null;
    },
    getFacilityInfo(id, name, addr, regDate) {
      this.initFacilityInfo();
      this.selectedFacilityInfo.stName = name;
      this.selectedFacilityInfo.stAddr = addr;
      this.selectedFacilityInfo.regDate = regDate;

      var reqBody = {
        stId: id,
      };
      this.$http
        .post("/structureStatus/getFacilityInfo", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let items = res.data.data;
            this.selectedFacilityInfo.stTypeMain = items[0].sttypemain;
            this.selectedFacilityInfo.stTypeSub = items[0].sttypesub;
            this.selectedFacilityInfo.projectName = items[0].projectName;
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      this.$http
        .post("/structureStatus/getFacilityPic", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let items = res.data.data;

            items.forEach((item) => {
              this.selectedFacilityInfo.image.push(item.base64Image);
            });

            if (this.selectedFacilityInfo.image != null) {
              this.selectedFacilityInfo.showImageEven =
                this.selectedFacilityInfo.image[0];
              if (this.selectedFacilityInfo.image.length > 1) {
                this.setImagePolling();
              }
            }
          } else {
            // this.setAlertTitle()
            // this.$bvModal.msgBoxOk('관리자에게 문의하세요.', this.getAlertOptions).then(value => {
            // }).catch(err => {
            //   console.error(err)
            // })
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setImagePolling() {
      this.selectedFacilityInfo.imagePolling = setInterval(() => {
        if (this.selectedFacilityInfo.showImageIdx === null) {
          this.selectedFacilityInfo.showImageIdx = 1;
        } else {
          this.selectedFacilityInfo.showImageIdx++;
        }

        if (
          this.selectedFacilityInfo.showImageIdx ===
          this.selectedFacilityInfo.image.length
        ) {
          this.selectedFacilityInfo.showImageIdx = 0;
        }

        if (this.selectedFacilityInfo.showImageIdx / 2 === 0) {
          this.selectedFacilityInfo.showImageEven =
            this.selectedFacilityInfo.image[
              this.selectedFacilityInfo.showImageIdx
            ];
        } else {
          this.selectedFacilityInfo.showImageOdd =
            this.selectedFacilityInfo.image[
              this.selectedFacilityInfo.showImageIdx
            ];
        }
      }, 3000);
    },
    destroyImagePolling() {
      if (this.selectedFacilityInfo.imagePolling != null) {
        clearInterval(this.selectedFacilityInfo.imagePolling);
        this.selectedFacilityInfo.imagePolling = null;
      }
    },
    expandSensorRatio() {
      this.$bvModal.show("sensorRatioModal");
      this.getAlarmSensorRatio(true);
    },
    getAlarmSensorRatio(isModal) {
      var reqBody = {};
      this.$http
        .post("/dashboard/getAlarmSensorRatio", reqBody, { timeout: 30 * 1000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (!isModal) {
              this.drawLineChart("projectAlarmSensorRatio", res.data.data);
            } else {
              let modal = document.getElementById(
                "projectAlarmSensorRatioModal"
              );
              if (modal) {
                this.drawLineChart(
                  "projectAlarmSensorRatioModal",
                  res.data.data
                );
              }
            }
          } else {
            this.setAlertTitle();
            this.$bvModal.msgBoxOk(
              "관리자에게 문의하세요.",
              this.getAlertOptions
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawLineChart(id, data) {
      let layout = chartUtil.setTimeLayout(
        id,
        {
          margin: {
            l: 50,
            r: 0,
            t: 0,
            b: 30,
            pad: 0,
          },
          legend: {
            font: {
              family: "Noto Sans KR",
              size: 12,
              color: "#b4b7bd",
              weight: "normal",
            },
          },
        },
        1,
        1
      );

      layout.xaxis.tickformat = "%m-%d %H";
      layout.xaxis.tickangle = "0";
      layout.yaxis.range = [-3, 103];
      layout.width = null;
      layout.height = null;
      layout.autosize = true;
      layout.hovermode = "closest";
      layout.showlegend = true;

      let config = { responsive: true, displayModeBar: false };
      Plotly.newPlot(id, data, layout, config);

      if (id == "projectAlarmSensorRatio") {
        this.isAlarmSensorRatioLoading = false;
      } else if (id == "projectAlarmSensorRatioModal") {
        this.isAlarmSensorRatioModalLoading = false;
      }
    },
    toggleLegend() {
      this.showLegend = !this.showLegend;
      Plotly.relayout("projectAlarmSensorRatio", {
        showlegend: this.showLegend,
        legend: {
          font: {
            family: "Noto Sans KR",
            size: 12,
            color: "#b4b7bd",
            weight: "normal",
          },
          title: {
            text: "프로젝트",
            font: {
              family: "Noto Sans KR",
              size: 15,
              color: "#b4b7bd",
              weight: "bold",
            },
          },
        },
      });
    },
    // map
    initializeMap() {
      this.$http
        .post("/options/getVworldMapKey", null, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.vworldMapKey = res.data.data;

            const rasterLayer = new TileLayer({
              source: new XYZ({
                url:
                  "https://api.vworld.kr/req/wmts/1.0.0/" +
                  this.vworldMapKey +
                  "/Base/{z}/{y}/{x}.png",
              }),
              // minZoom: 6.9,
              zIndex: 0,
              preload: Infinity,
            });
            const markerLayer = new VectorLayer({
              source: this.markerSource,
            });

            this.view = new View({
              center: new Point(defaultPoint)
                .transform(src, dest)
                .getCoordinates(),
              projection: "EPSG:3857",
              minZoom: 6,
              zoom: 8,
            });

            this.map = new Map({
              layers: [rasterLayer, markerLayer],
              controls: [],
              target: "map",
              view: this.view,
              interactions: defaults({ doubleClickZoom: false }),
            });

            this.map.on("singleclick", (evt) => {
              this.setMapClickEvent(evt);
            });

            this.map.on("pointermove", (evt) => {
              if (evt.dragging) {
                info.style.visibility = "hidden";
                this.selectedMarkerFeature = undefined;
                return;
              }
              const pixel = this.map.getEventPixel(evt.originalEvent);
              var hit = this.map.hasFeatureAtPixel(pixel);
              this.map.getViewport().style.cursor = hit ? "pointer" : "";
              this.displayFeatureInfo(pixel, evt.originalEvent.target);
            });

            this.makeMarker();
          } else {
            this.setAlertTitle("Vworld 맵 키 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    displayFeatureInfo(pixel, target) {
      const feature = target.closest(".ol-control")
        ? undefined
        : this.map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature;
          });
      const info = document.getElementById("info");
      if (feature) {
        info.style.left = pixel[0] + "px";
        info.style.top = pixel[1] + 40 + "px";
        if (feature !== this.selectedMarkerFeature) {
          info.style.visibility = "visible";
          info.innerText = feature.values_.data.structureName;
        }
      } else {
        info.style.visibility = "hidden";
      }
      // this.selectedMarkerFeature = feature;
    },

    setMapClickEvent(evt) {
      let feature = this.map.forEachFeatureAtPixel(
        evt.pixel,
        function (feature, layer) {
          return feature;
        }
      );

      if (feature) {
        if (feature.getId()) {
          if (this.selectedMarkerFeature) {
            this.setUnSelectMarkerStyle(this.selectedMarkerFeature);
            this.selectedMarkerFeature = null;
          }

          feature = this.setSelectMarkerStyle(feature);
          this.selectedMarkerFeature = feature;

          let data = feature.values_.data;

          this.isFacilityInfoVisible = true;
          this.getFacilityInfo(
            data.structureId,
            data.structureName,
            data.structureAddress,
            data.structureRegistrationDate
          );
          this.getWeatherInfo(data.structureId);
          this.getChartData(data.structureId);
          this.setMapView(data.lng, data.lat, 12, true);
        }
      } else {
        this.reset();
      }
    },
    setSelectMarkerStyle(feature) {
      let style = feature.getStyle();
      style.getImage().setScale(1);
      // style.setImage(
      //   new Icon({
      //     crossOrigin: "anonymous",
      //     src: this.markerIconSrc,
      //     scale: 1,
      //   })
      // );
      // feature.setStyle(style);
      feature.changed();
      return feature;
    },
    setUnSelectMarkerStyle(feature) {
      let style = feature.getStyle();
      // style.setImage(
      //   new Icon({
      //     crossOrigin: "anonymous",
      //     src: this.markerIconSrc,
      //     scale: 0.5,
      //   })
      // );
      // feature.setStyle(style);
      style.getImage().setScale(0.5);
      feature.changed();
      return feature;
    },
    makeMarker(viewReset = true) {
      this.markerSource.clear();

      if (this.structureList != null && this.structureList.length > 0) {
        for (let i = 0; i < this.structureList.length; i++) {
          let data = this.structureList[i];

          let isCaution = false;
          if (data && data.hasOwnProperty("sensorErrorCnt")) {
            isCaution = data.sensorErrorCnt > 0;
          }

          if (this.isShowOnlyAlarmStructure && !isCaution) {
            continue;
          }

          let iconPath = this.getMarkerIcon(isCaution);

          let location = new Point([
            parseFloat(data.lng),
            parseFloat(data.lat),
          ]).transform(src, dest);

          let scale = 0.5;
          let feature = new Feature({
            geometry: location,
            data: data,
          });

          feature.setStyle(
            new Style({
              image: new Icon({
                crossOrigin: "anonymous",
                src: iconPath,
                scale: scale,
              }),
              text: null,
            })
          );
          feature.setId(data.structureId);
          this.markerSource.addFeature(feature);
        }
        if (viewReset) {
          this.setMapView(null, null, null, false);
        }
      }
    },
    getMarkerIcon(isCaution) {
      let color = isCaution ? "red" : "blue";
      return `./static/img/location_${color}.png`;
    },
    setMapView(lng, lat, zoom, alertFlag) {
      if (lng == null || lat == null) {
        lng = defaultPoint[0];
        lat = defaultPoint[1];

        if (alertFlag) {
          this.$bvToast.toast("위치 정보가 없습니다", {
            title: "Warning message",
            variant: "warning",
            autoHideDelay: 4000,
            solid: true,
          });
        }
      }

      if (zoom === null) {
        const rootWidth = document.getElementsByTagName("html")[0].offsetWidth;
        if (rootWidth >= 2240) {
          zoom = 8;
        } else {
          zoom = 7.67;
        }
      }

      this.map
        .getView()
        .setCenter(
          new Point([parseFloat(lng), parseFloat(lat)])
            .transform(src, dest)
            .getCoordinates()
        );
      if (zoom != null && zoom != undefined) {
        this.map.getView().setZoom(zoom);
      }
    },
    toggleWeatherPanel() {
      this.isVisibleWeatherPanel = !this.isVisibleWeatherPanel;
      setTimeout(() => {
        this.resizeWeatherChart();
      }, 500);
    },
    toggleShowOnlyAlarmStructure() {
      this.isShowOnlyAlarmStructure = !this.isShowOnlyAlarmStructure;
      this.makeMarker(false);
    },
    getWeatherInfo(structureId) {
      var reqBody = {
        stid: structureId,
      };
      this.$http
        .post("/weather/getWeatherIn24Hours", reqBody, {
          timeout: 15 * 1000,
        })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            if (res.data.data.length > 0) {
              const data = res.data.data;
              const times = data
                .map((item) => item.forecastDateTime)
                .slice(0, 24);
              const temperature = data.map((item) => item["TMP"]).slice(0, 24);
              const humidity = data.map((item) => item["REH"]).slice(0, 24);
              this.drawMultipleLineChart("weatherChart", {
                times: times,
                temperature: temperature,
                humidity: humidity,
              });
            }
          } else {
            Plotly.purge("weatherChart");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    drawMultipleLineChart(id, source) {
      let data = [
        {
          x: source.times,
          y: source.temperature,
          name: "temp",
          type: "scatter",
          mode: "lines+markers+text",
          name: "온도",
          hovertemplate: "%{x}시 %{y}°C",
          // text: source.temperature,
          // textposition: "top center",
          // textfont: { color: "#fff" },
        },
        {
          x: source.times,
          y: source.humidity,
          name: "humidity",
          type: "scatter",
          mode: "lines+markers",
          name: "습도",
          yaxis: "y2",
          hovertemplate: "%{x}시 %{y}%",
          // textposition: "top center",
          // textfont: { color: "#fff" },
        },
      ];
      let layout = {
        xaxis: {
          title: "시간",
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%m/%d %H",
          tickmode: "auto",
          nticks: source.times.length > 2 ? 2 : source.times.length,
          tickangle: "0",
        },
        yaxis: {
          title: "온도(°C)",
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          tickmode: "auto",
          nticks: source.temperature.length > 4 ? 4 : source.temperature.length,
        },
        yaxis2: {
          title: "습도(%)",
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          tickmode: "auto",
          nticks: source.humidity.length > 4 ? 4 : source.humidity.length,
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        margin: {
          l: 60,
          r: 60,
          t: 20,
          b: 40,
          pad: 0,
        },
        showlegend: false,
        autosize: true,
        hovermode: "closest",
      };

      const weatherDiv = document.getElementById("weatherChart");
      const width = weatherDiv.offsetWidth;
      layout.width = width || 587;
      layout.height = 160;

      let config = { responsive: true };
      Plotly.newPlot(id, data, layout, config);
    },
    resizeWeatherChart() {
      if (this.isFacilityInfoVisible && this.isVisibleWeatherPanel) {
        const weatherDiv = document.getElementById("weatherChart");
        const width = weatherDiv.offsetWidth;
        Plotly.relayout("weatherChart", { width: width });
      }
    },

    getChartData(structureId) {
      if (
        structureId === null ||
        structureId === undefined ||
        this.search.samplecnt === null
      )
        return;

      this.initChartGraph();
      this.isLoading = true;
      var reqBody = {
        stid: structureId,
        stdate: moment().subtract(6, "days").format("YYYYMMDD"),
        eddate: moment().format("YYYYMMDD"),
        samplecnt: 100,
      };
      this.$http
        .post("/sensor/getChartDataList", reqBody, { timeout: 120000 })
        .then((res) => {
          if (res.data.resultyn === "Y") {
            var chartData = res.data.data.data;
            this.chartRange = res.data.data.chartRange;
            this.chartRangeList = res.data.data.chartRangeList;

            this.chartData = [];
            this.graphRowCnt = chartData.length;
            for (let i = 0; i < chartData.length; i++) {
              // Change Time Format
              for (let j = 0; j < chartData[i].chart_data.time.length; j++) {
                chartData[i].chart_data.time[j] = moment(
                  chartData[i].chart_data.time[j] * 1000
                ).format("YYYY-MM-DD HH:mm:ss");
              }

              this.chartData.push({
                title: chartData[i].sensor_alias,
                devname: utils.chkNull(chartData[i].device_name, null),
                devtype: chartData[i].device_type,
                chan: utils.chkNull(chartData[i].ch_no, null),
                data: chartData[i].chart_data,
                sensormodel: chartData[i].sensor_model,
                unit: chartData[i].unit,
                codeval: chartData[i].codeval,
                sensorIdx: chartData[i].sensorIdx,
                stid: chartData[i].stid,
              });
            }
            this.$nextTick(() => {
              this.isBlankPanel = false;
              this.isLoading = false;
              this.redrawChart();
            });
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },
    initChartGraph() {
      for (let i = 0; i < this.chartData.length; i++) {
        if (this.isDynamicSensor(this.chartData[i].devtype) && !this.isCableTensionSensor(this.chartData[i].sensormodel)) {
          Plotly.purge("analChart" + (i + 1));
        } else {
          Plotly.purge("svChart" + (i + 1));
        }
      }
      this.isGnss = false;
      this.isBlankPanel = true;
    },
    chartTitle(data) {
      let title = "";
      if (this.isDynamicSensor(data.devtype) && !this.isCableTensionSensor(data.sensormodel)) {
        title = data.title + " ANAL1/ANAL2";
      } else if (this.isTotalStation(data.devtype)) {
        title = data.title + " 광파기";
      } else {
        title = data.title + " S-V";
      }
      return title;
    },
    redrawChart() {
      for (let i = 0; i < this.chartData.length; i++) {
        try {
          let chartid = null;
          if (this.isDynamicSensor(this.chartData[i].devtype) && !this.isCableTensionSensor(this.chartData[i].sensormodel)) {
            chartid = "analChart" + (i + 1);
            this.drawDualAxisTimeLineChart(chartid, {
              x: this.chartData[i].data["time"],
              y1: this.chartData[i].data["ANAL_1"],
              name1: "anal1",
              title1: "ANAL_1(ma.u)",
              y2: this.chartData[i].data["ANAL_2"],
              name2: "anal2",
              title2: "ANAL_2(ma.u)",
              sensorIdx: this.chartData[i].sensorIdx,
              stid: this.chartData[i].stid,
            });
          } else if (
            this.isBGW(this.chartData[i].devtype) ||
            this.isLGW(this.chartData[i].devtype) ||
            this.isOptiFBG(this.chartData[i].devtype) ||
            this.isCableTensionSensor(this.chartData[i].sensormodel)
          ) {
            chartid = "svChart" + (i + 1);
            this.drawTimeLineChart(chartid, [
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["data"],
                name: "S-V",
                title: this.chartData[i].unit,
                sensorIdx: this.chartData[i].sensorIdx,
                stid: this.chartData[i].stid,
              },
            ]);
          } else if (this.isGNSS(this.chartData[i].devtype)) {
            let chartid = null;
            chartid = "latitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, [
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["LATITUDE"],
                name: "latitude",
              },
            ]);
            chartid = "longitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, [
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["LONGITUDE"],
                name: "longitude",
              },
            ]);
            chartid = "altitudeChart" + (i + 1);
            this.drawTimeLineChart(chartid, [
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["ALTITUDE"],
                name: "altitude",
              },
            ]);
          } else if (this.isTotalStation(this.chartData[i].devtype)) {
            let chartid = "svChart" + (i + 1);
            this.drawTimeLineChart(chartid, [
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["dx"],
                name: "dx",
                title: "mm",
              },
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["dy"],
                name: "dy",
                title: "mm",
              },
              {
                x: this.chartData[i].data["time"],
                y: this.chartData[i].data["dz"],
                name: "dz",
                title: "mm",
              },
            ]);
          }
        } catch (err) {
          console.error(err);
        }
        this.LoadYn = false;
      }
    },
    // x축이 시간인 라인 차트 그리기
    drawTimeLineChart(id, param) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      let Data = [];
      for (var i = 0; i < param.length; i++) {
        Data.push({
          x: param[i].x,
          y: param[i].y,
          name: param[i].name,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        });
      }

      var tmpLayout = document.getElementById(id);
      let layout = {
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%Y-%m-%d %H:%M:%S",
          tickmode: "auto",
          nticks: param[0].x.length > 2 ? 2 : param[0].x.length,
          tickangle: 0,
        },
        yaxis: {
          title: param[0].title,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          nticks: param[0].y.length > 4 ? 4 : param[0].y.length,
          dtick: dtick,
          range: [yAxisMin, yAxisMax],
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        width: Math.floor(tmpLayout.parentElement.clientWidth - 1),
        height: Math.floor(tmpLayout.parentElement.clientHeight - 1),
        showlegend: Data.length > 1 ? true : false,
        legend: {
          font: {
            color: "#b4b7bd",
          },
        },
        margin: {
          l: 80,
          r: 50,
          t: 20,
          b: 30,
          pad: 0,
        },
        annotations: [],
      };
      Plotly.newPlot(id, Data, layout, { displaylogo: false });
    },
    // x축이 시간이면서 Y축이 좌우인 라인 차트 그리기
    drawDualAxisTimeLineChart(id, param) {
      const { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 } =
        utils.getChartRangeValues(this.chartRangeList, this.chartRange, param);

      var Data = [
        {
          x: param.x,
          y: param.y1,
          name: param.name1,
          type: "scatter",
          mode: "lines",
          line: { width: 1 },
        },
        {
          x: param.x,
          y: param.y2,
          name: param.name2,
          type: "scatter",
          mode: "lines",
          yaxis: "y2",
          line: { width: 1 },
        },
      ];
      var tmpLayout = document.getElementById(id);
      let layout = {
        xaxis: {
          zeroline: false,
          color: "#b4b7bd",
          tickformat: "%Y-%m-%d %H:%M:%S",
          tickmode: "auto",
          nticks: param.x.length > 2 ? 2 : param.x.length,
          tickangle: 0,
        },
        yaxis: {
          title: param.title1,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          nticks: param.y1.length > 4 ? 4 : param.y1.length,
          dtick: dtick,
          range: [yAxisMin, yAxisMax],
        },
        yaxis2: {
          title: param.title2,
          titlefont: {
            family: "Noto Sans KR",
            size: 14,
            weight: "normal",
          },
          zeroline: false,
          color: "#b4b7bd",
          overlaying: "y",
          side: "right",
          nticks: param.y2.length > 4 ? 4 : param.y2.length,
          dtick: dtick2,
          range: [yAxisMin2, yAxisMax2],
        },
        paper_bgcolor: "#283046",
        plot_bgcolor: "#283046",
        width: Math.floor(tmpLayout.parentElement.clientWidth - 1),
        height: Math.floor(tmpLayout.parentElement.clientHeight - 1),
        margin: {
          l: 80,
          r: 80,
          t: 20,
          b: 30,
          pad: 0,
        },
        showlegend: false,
        annotations: [],
      };
      Plotly.newPlot(id, Data, layout, {
        displaylogo: false,
        responsive: true,
      });
    },
  },
};
</script>

<template>
  <b-row id="dashboardAdv" class="animated fadeIn h-100">
    <b-col class="col-4">
      <b-row>
        <b-card header-tag="header" class="border0" body-class="h-100 p-0">
          <h6 slot="header"><i class="far fa-hdd mr8"></i>프로젝트 현황</h6>
          <ag-grid-vue
            class="ag-theme-balham projectStatGrid"
            :gridOptions="project"
          ></ag-grid-vue>
        </b-card>
      </b-row>
      <b-row>
        <b-card header-tag="header" class="border0" body-class="h-100 p-0">
          <h6 slot="header"><i class="far fa-hdd mr8"></i>구조물 현황</h6>
          <div class="status-border">
            <div class="contentCount">
              <div
                v-for="(item, index) in statusBorder.structureTypeCnt"
                :key="index"
                class="type-cnt-box"
              >
                <div class="type-cnt-box-title">
                  {{ item.sttypemain }}
                </div>
                <div class="type-cnt-box-content">
                  {{ item.cnt }}
                </div>
              </div>
            </div>

            <div class="searchBox">
              <div class="row">
                <div class="searchItem">
                  <label>프로젝트</label>
                  <dropdown-checkbox
                    class="searchDropdown"
                    :options="search.project.options"
                    @change="onChangeProject"
                  >
                  </dropdown-checkbox>
                </div>
                <div class="searchItem">
                  <label>구조물</label>
                  <dropdown-checkbox
                    class="searchDropdown"
                    :options="search.structure.options"
                    @change="onChangeStructure"
                  >
                  </dropdown-checkbox>
                </div>
                <div class="searchItem">
                  <label>장애 종류</label>
                  <dropdown-checkbox
                    class="searchDropdown"
                    :options="search.condition.options"
                    @change="onChangeCondition"
                  >
                  </dropdown-checkbox>
                </div>
                <b-button class="searchBtn mr10" @click="getStructureStatus"
                  >조회
                </b-button>
              </div>
            </div>

            <div class="content">
              <div
                v-for="(item, index) in statusBorder.structureStatus"
                :key="index"
                class="status-box"
                @click="changeData(item)"
              >
                <div
                  style="width: 100%; height: 100%"
                  v-if="item.sensorErrorCnt === 0"
                >
                  <div class="status-box-title">
                    <img
                      src="/static/img/sensor_success.png"
                      class="wifiImage"
                    />
                    <span style="color: #e8edf3">{{ item.structureName }}</span>
                  </div>
                  <div class="status-box-content">
                    <div>
                      <span>센서: </span>
                      <span class="successed-color">{{ item.sensorCnt }}</span>
                    </div>
                    <div>
                      <span>장애: </span>
                      <span class="nomal-color">{{ item.sensorErrorCnt }}</span>
                    </div>
                  </div>
                </div>

                <div
                  style="width: 100%; height: 100%"
                  class="border-error-effect"
                  v-else
                >
                  <div class="status-box-title">
                    <img
                      src="/static/img/sensor_error.png"
                      class="wifiImage error-effect"
                    />
                    <span style="color: #e8edf3">{{ item.structureName }}</span>
                  </div>
                  <div class="status-box-content">
                    <div>
                      <span>센서: </span>
                      <span class="successed-color">{{ item.sensorCnt }}</span>
                    </div>
                    <div>
                      <span>장애: </span>
                      <span class="failed-color">{{
                        item.sensorErrorCnt
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-row>
      <b-row>
        <b-card
          header-tag="header"
          class="border0"
          body-class="h-100 p-0"
          style="position: relative"
        >
          <h6 slot="header" class="d-flex justify-content-between">
            <div><i class="far fa-hdd mr8"></i>센서 장애율</div>
            <div>
              <b-button
                slot="header"
                headerBtn
                class="headerBtn"
                @click="toggleLegend"
                v-b-tooltip.hover
                title="범례 표시/숨김"
              >
                <i class="fas fa-list mr8"></i>
              </b-button>
              <b-button
                class="headerBtn"
                @click="expandSensorRatio"
                v-b-tooltip.hover
                title="큰 화면으로 보기"
              >
                <i class="fas fa-expand"></i>
              </b-button>
            </div>
          </h6>
          <div id="projectAlarmSensorRatio" class="graphStyle"></div>
          <div v-if="isAlarmSensorRatioLoading" class="loaderContainer">
            <span class="loader"></span>
          </div>
        </b-card>
      </b-row>
    </b-col>

    <b-col class="col-4">
      <div class="mapSearchBar searchBox">
        <div>
          <label>검색</label>
          <vue-select
            class="select-container w300 mr10"
            v-model="modelValue"
            :options="structureList"
            :reduce="(a) => a.structureId"
            label="structureName"
            :clearable="false"
            required
          ></vue-select>
          <b-button class="searchBtn" @click="searchStructure">조회</b-button>
          <b-button class="resetBtn" @click="reset"
            ><i class="fas fa-undo-alt"></i
          ></b-button>
        </div>
      </div>
      <div class="mapPanel" id="map">
        <div id="info"></div>
        <div
          class="floatingPanel top"
          v-show="isFacilityInfoVisible && isVisibleWeatherPanel"
        >
          <div id="weatherChart"></div>
        </div>
        <div id="toggleButton" class="searchBox p0">
          <div>
            <b-button
              @click="toggleShowOnlyAlarmStructure"
              class="searchBtn"
              v-b-tooltip.hover
              :title="
                isShowOnlyAlarmStructure
                  ? '모든 구조물 표시'
                  : '장애 구조물만 표시'
              "
            >
              <i
                :class="[
                  'fas',
                  'fa-exclamation-triangle',
                  { 'text-danger': isShowOnlyAlarmStructure },
                ]"
                style="margin: 0"
              ></i>
            </b-button>

            <b-button
              @click="toggleWeatherPanel"
              class="searchBtn"
              v-b-tooltip.hover
              title="선택한 구조물의 기상 예보 표시"
            >
              <i :class="weatherIcon"></i>
              <span>기상 예보</span>
            </b-button>
          </div>
        </div>
        <div class="floatingPanel bottom" v-show="isFacilityInfoVisible">
          <div class="bottom-info-div">
            <div class="show-image-container">
              <transition name="slide-fade" mode="out-in">
                <img
                  :src="selectedFacilityInfo.showImageEven"
                  :key="selectedFacilityInfo.showImageEven"
                  class="show-image"
                  v-if="selectedFacilityInfo.showImageIdx / 2 === 0"
                />
                <img
                  :src="selectedFacilityInfo.showImageOdd"
                  :key="selectedFacilityInfo.showImageOdd"
                  class="show-image"
                  v-else
                />
              </transition>
            </div>
            <div class="bottom-info-container">
              <div class="bottom-info-title-content">
                <div class="bottom-info-title-main">
                  {{ selectedFacilityInfo.projectName }}
                </div>
                <div class="bottom-info-title-main">
                  {{ selectedFacilityInfo.stName }}
                </div>
                <div class="bottom-info-title-sub">
                  {{ selectedFacilityInfo.stAddr }}
                </div>
              </div>
              <div class="bottom-info-body-content">
                <div class="bottom-info-body-main">
                  <label>시설물 유형</label>
                  <label>시설물</label>
                  <label>등록일</label>
                </div>
                <div class="bottom-info-body-sub">
                  <label>{{ selectedFacilityInfo.stTypeMain }}</label>
                  <label>{{ selectedFacilityInfo.stTypeSub }}</label>
                  <label>{{ selectedFacilityInfo.regDate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-col>

    <b-col class="col-4">
      <b-card header-tag="header" class="border0" body-class="h-100 p-0 mb10">
        <h6 slot="header">
          <i class="far fa-hdd mr8"></i>구조물 센서 데이터 현황
        </h6>
        <div class="charts">
          <div class="chartElement" v-for="(item, idx) in chartData" :key="idx">
            <b-card
              class="default-border1 mx10"
              body-class="h-100 p0"
              header-tag="header"
            >
              <h6 slot="header">{{ chartTitle(item) }}</h6>
              <div
                :id="
                  (isDynamicSensor(item.devtype) && !isCableTensionSensor(item.sensormodel)
                    ? 'analChart'
                    : 'svChart') + (idx + 1)
                "
                class="default-border-top1"
              ></div>
            </b-card>
          </div>
        </div>
        <div v-show="isBlankPanel" class="blankPanel">
          <span>
            좌측에서 구조물 선택 시<br />
            센서의 최근 7일 데이터 차트가<br />
            표시됩니다
          </span>
        </div>
        <div v-show="isLoading" id="loader-small" class="chartLoading">
          <div class="spinner-bar-small">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </b-card>
    </b-col>

    <b-modal
      id="sensorRatioModal"
      title="센서 장애율"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
    >
      <div class="projectAlarmSensorRatio">
        <div id="projectAlarmSensorRatioModal" class="graphStyle"></div>
        <div v-if="isAlarmSensorRatioModalLoading" class="loaderContainer">
          <span class="loader"></span>
        </div>
      </div>
    </b-modal>
  </b-row>
</template>

<style lang="scss">
#dashboardAdv {
  .col {
    width: 100%;
    height: 100%;
    padding: 1rem 0.5rem;

    .row {
      width: 100%;
      height: calc((100% - 2rem) / 3);
    }

    .row + .row {
      margin-top: 1rem;
    }
  }

  & div.ag-theme-balham.projectStatGrid {
    height: 100%;
    border-radius: 0 0 8px 8px;
    & .ag-root .ag-body .ag-body-viewport {
      overflow-x: hidden;
    }
  }
  .ag-theme-balham .ag-header-cell,
  .ag-theme-balham .ag-header-group-cell {
    padding: 0;
  }
  .ag-theme-balham
    .ag-root
    .ag-header
    .ag-header-row
    .ag-header-group-cell-label
    span {
    padding-left: 0 !important;
  }
  .alarmTable {
    height: calc(100% - 45px);
    border-radius: 0 0 8px 8px;
  }

  & .card {
    width: 100%;
    height: 100%;
    // overflow: hidden;
    & .card-header {
      padding: 13px 20px;
      & h6 {
        font-size: 16px;
        line-height: unset;
      }
    }
  }
  .alarmStat {
    display: flex;
    justify-content: space-evenly;
    cursor: pointer;
  }
  .iconBox-3 {
    height: 100%;
    display: flex;
    align-items: center;
    color: #e2e2e2;
    &.sep::after {
      content: "";
      width: 2px;
      height: 30px;
      position: absolute;
      right: -0.5px;
      border-right: 2px solid #e0e3e6;
    }
    & > div {
      display: flex;
      flex-direction: row;
      font-family: "Noto Sans KR", sans-serif;
      &:only-child {
        margin: 0 auto;
      }
      & .head {
        margin: 0 15px 0 7px;
        align-content: center;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
      }
      & .cont {
        margin: 0 7px 0 0;
        width: auto;
        font-size: 18px;
        font-weight: 500;
      }
    }
  }

  .graphStyle {
    height: 100%;
    width: 100%;
  }

  .mapSearchBar {
    width: 100%;
    height: 50px;
    background-color: #283046;
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: row;
    padding: 10px 8px;
    color: #b4b7bd;
    label {
      width: 50px;
      height: 30px;
      display: flex;
      align-items: center;
      margin-bottom: 0px;
    }
    select {
      width: 200px;
      height: 30px;
    }
  }
  .mapPanel {
    width: 100%;
    height: calc(100% - 50px);
    border-radius: 0 0 8px 8px;
    overflow: hidden;
  }
  .floatingPanel {
    width: calc(100% - 3rem);
    height: 10rem;
    position: absolute;
    left: 1.5rem;
    z-index: 2;
    border: 1px solid;
    border-radius: 8px;
    background-color: #283046;
  }
  .top {
    top: calc(50px + 4rem);
  }
  .bottom {
    bottom: 2rem;
    height: 172px;
  }
  #weatherChart {
    .main-svg {
      border-radius: 8px;
    }
  }
  #toggleButton {
    position: absolute;
    top: calc(50px + 2rem);
    right: 1.5rem;
    width: auto;
    height: 30px;
    background-color: transparent;
    z-index: 4;
    cursor: pointer;
    font-size: 1rem;
  }
  .headerBtn {
    width: auto;
    height: 100%;
    background-color: #7367f0;
    border: none;
    border-radius: 5px;
    padding: 4px 10px;
    color: #fff;

    &:hover {
      background-color: #5c52c5;
    }

    i {
      margin: 0 !important;
    }
  }

  @media all and (max-width: 2200px) {
    & .ag-header {
      & .ag-header-row {
        & .ag-header-group-cell-label span,
        & .ag-header-cell-label {
          text-align: center;
          width: 100%;

          .ag-header-cell-text {
            font-size: 10px !important;
            padding-left: 0px !important;
          }
        }
        .ag-header-cell-menu-button {
          width: 0px;
        }
        .ag-header-group-text {
          font-size: 10px !important;
          padding-left: 0px !important;
        }
      }
    }
    .status-border {
      width: 100%;
      height: 100%;
      padding: 1px;
      display: flex;
      flex-direction: column;

      .contentCount {
        width: 100%;
        margin-bottom: 1px;
        display: flex;
        flex-wrap: wrap;
        background: #283046;
        color: #fff;

        & .type-cnt-box {
          width: calc(100% / 3);
          text-align: center;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          & .type-cnt-box-title {
            height: 20px;
            color: #86cee2;
            font-weight: bold;
            font-size: 15px;
            margin-right: 10px;
          }
          & .type-cnt-box-content {
            height: 25px;
            color: #effaff;
            font-weight: bold;
            font-size: 20px;
          }
        }
      }

      .searchBox {
        display: flex;
        flex-direction: column;
        width: auto;
        margin-bottom: 1px;
        padding-right: 0px;

        .row {
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .searchItem {
            width: calc((100% - 70px) / 3);
            height: 100%;
            display: flex;
            align-items: center;

            label {
              // width: auto;
              margin-bottom: 0;
            }

            .searchDropdown {
              width: calc(100% - 80px);
              height: 32px;
            }

            select {
              width: calc(100% - 90px) !important;
              margin-right: 10px !important;
            }
          }
        }
      }

      & .content {
        width: 100%;
        height: calc(100% - 75px);
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        overflow: auto;
        background: #283046;
        color: #fff;

        & .status-box {
          width: calc((100% - 16px) / 4);
          max-height: 60px;
          margin: 0 2px 2px 2px;
          text-align: center;
          border-radius: 7px;
          border: 1px outset #4b546d;
          background-color: #2f374c;
          cursor: pointer;

          & .status-box-title {
            height: 20px;
            margin-bottom: 3px;
            text-overflow: ellipsis;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #fff;
            font-size: 15px;
            font-weight: bold;
            display: flex;
            align-items: center;

            span {
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .wifiImage {
              width: 15px;
              height: 15px;
              margin: 0 13px 0 5px;
              border-radius: 10px;
            }
          }

          & .status-box-content {
            height: 25px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            font-weight: bold;
            color: #fff;
          }
        }

        & .status-box:active {
          border-color: #a4acc1;
          background-color: #45547b;
        }
      }
    }
    & .successed-color {
      color: #8bd886;
      font-size: 15px;
    }
    & .failed-color {
      color: #fd7e7e;
      font-size: 15px;
    }
    & .nomal-color {
      color: #fff;
      font-size: 15px;
    }
  }
  @media all and (min-width: 2201px) {
    .status-border {
      width: 100%;
      height: 100%;
      padding: 1px;
      display: flex;
      flex-direction: column;

      .contentCount {
        width: 100%;
        height: 81px;
        padding: 10px;
        margin-bottom: 1px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        overflow: auto;
        background: #283046;
        color: #fff;

        & .type-cnt-box {
          width: 100px;
          height: 60px;
          text-align: center;

          & .type-cnt-box-title {
            height: 20px;
            line-height: 30px;
            color: #86cee2;
            font-weight: bold;
          }

          & .type-cnt-box-content {
            height: 40px;
            color: #effaff;
            font-weight: bold;
            font-size: 30px;
          }
        }
      }

      .searchBox {
        display: flex;
        flex-direction: column;
        margin-bottom: 1px;
        padding-right: 0px;

        .row {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .searchItem {
            width: 25%;
            height: 100%;
            display: flex;
            align-items: center;

            label {
              // width: 70px;
              margin-bottom: 0;
            }

            .searchDropdown {
              width: calc(100% - 80px);
              height: 32px;
            }

            select {
              width: calc(100% - 90px) !important;
              margin-right: 10px !important;
            }
          }
        }
      }

      & .content {
        width: 100%;
        height: calc(100% - 130px);
        // padding: 10px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        overflow: auto;
        background: #283046;
        color: #fff;

        & .status-box {
          width: calc((100% - 20px) / 5);
          max-height: 80px;
          margin: 0 2px 2px 2px;
          text-align: center;
          border-radius: 7px;
          border: 1px outset #4b546d;
          background-color: #2f374c;
          cursor: pointer;

          & .status-box-title {
            height: 35px;
            line-height: 35px;
            margin-bottom: 3px;
            text-overflow: ellipsis;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            display: flex;
            align-items: center;

            span {
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .wifiImage {
              width: 20px;
              height: 20px;
              margin: 0 13px 0 5px;
              border-radius: 10px;
            }
          }

          & .status-box-content {
            height: 35px;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            font-weight: bold;
            color: #fff;
          }
        }

        & .status-box:active {
          border-color: #a4acc1;
          background-color: #45547b;
        }
      }
    }
    & .successed-color {
      color: #8bd886;
      font-size: 20px;
    }
    & .failed-color {
      color: #fd7e7e;
      font-size: 20px;
    }
    & .nomal-color {
      color: #fff;
      font-size: 20px;
    }
  }

  & .error-effect {
    animation: error-effect 2s ease infinite;
    -moz-animation: error-effect 2s ease infinite;
    -webkit-animation: error-effect 2s ease infinite;
  }
  @keyframes error-effect {
    0%,
    50% {
      background: transparent;
      border: none;
    }
    100% {
      background: red;
      border: 1px outset #f3c5c5;
    }
  }
  & .border-error-effect {
    animation: border-error-effect 2s ease infinite;
    -moz-animation: border-error-effect 2s ease infinite;
    -webkit-animation: border-error-effect 2s ease infinite;
  }
  @keyframes border-error-effect {
    0%,
    50% {
      border: 2px outset #4b546d;
      border-radius: 7px;
    }
    100% {
      border: 2px outset #ff4444;
      border-radius: 7px;
    }
  }

  & .bottom-info-div {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    padding: 7px;

    & .show-image-container {
      width: calc(50% - 10px);
      height: 100%;
      margin-right: 10px;
      border: 2px ridge #8ea0d2;
      border-radius: 5px;
      text-align: center;

      .slide-fade-enter-active {
        transition: all 0.5s ease;
      }
      .slide-fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
      }
      .slide-fade-enter,
      .slide-fade-leave-to {
        transform: translateX(0px);
        opacity: 0;
      }

      & .show-image {
        // width: 100%;
        // height: 100%;
        max-width: 100%;
        max-height: 100%;
        border-radius: 5px;
        border: 1px solid #555;
        // border: 4px ridge #8ea0d2;
      }
    }

    & .bottom-info-container {
      display: flex;
      flex-direction: column;
      width: 50%;
      height: 100%;

      & .bottom-info-title-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 72px;
        border-bottom: 1px dotted #9ba6b9;

        & .bottom-info-title-main {
          font-size: 18px;
          color: #fff;
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        & .bottom-info-title-sub {
          font-size: 12px;
          color: #8ab9ff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      & .bottom-info-body-content {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: calc(100% - 55px);
        margin-top: 5px;
        font-size: 15px;

        & .bottom-info-body-main {
          display: flex;
          flex-direction: column;
          width: 40%;
          height: 100%;
          color: #8ed2ec;
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        & .bottom-info-body-sub {
          display: flex;
          flex-direction: column;
          width: 60%;
          height: 100%;
          color: #fff;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  #info {
    position: absolute;
    display: inline-block;
    height: auto;
    width: auto;
    z-index: 100;
    background-color: #fff;
    color: #000;
    font-weight: bold;
    text-align: center;
    border: 2px solid #00f;
    border-radius: 4px;
    padding: 5px;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    pointer-events: none;
  }
  .floatingText {
    color: #fff;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 360px;
  }
  .charts {
    width: 100%;
    height: 100%;
    overflow-y: auto;

    .chartElement {
      height: 200px;
      overflow: hidden;
    }
    .chartElement + .chartElement {
      margin-top: 1rem;
    }
  }

  .blankPanel {
    width: 100%;
    height: calc(100% - 55px);
    background: #283046;
    position: absolute;
    top: 45px;
    left: 0px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    span {
      color: #bebebe;
      font-size: 1rem;
      font-weight: 600;
    }
  }
  .chartLoading {
    width: 100%;
    height: calc(100% - 55px);
    position: absolute;
    top: 45px;
    left: 0px;
    z-index: 3;
    background-color: rgba(0, 0, 0, 0.3);

    & .spinner-bar-small {
      position: absolute;
      top: calc(50% - 12.5px);
      left: calc(50% - 12.5px);
      width: 50px;
      height: 50px;
      border-radius: 100%;
      margin: 0 auto;

      & span {
        display: inline-block;
        width: 5px;
        height: 30px;
        background-color: rgba(230, 232, 233, 0.6);
        &:nth-child(1) {
          animation: spinner-bar 1s ease-in-out infinite;
        }
        &:nth-child(2) {
          animation: spinner-bar 1s ease-in-out 0.15s infinite;
        }
        &:nth-child(3) {
          animation: spinner-bar 1s ease-in-out 0.3s infinite;
        }
        &:nth-child(4) {
          animation: spinner-bar 1s ease-in-out 0.45s infinite;
        }
      }
    }
  }

  @keyframes spinner-bar-small {
    0% {
      transform: scaleY(1);
    }
    50% {
      transform: scaleY(1.8);
    }
    100% {
      transform: scaleY(1);
    }
  }
}

#sensorRatioModal {
  .modal-dialog {
    max-width: 1200px;
    height: 80vh;
  }

  .projectAlarmSensorRatio {
    position: relative;
    min-height: 450px;
    padding: 10px;
  }
}

.loaderContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .loader {
    width: 48px;
    height: 48px;
    border: 5px solid #fff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/DashboardAdv.vue